import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Logo.png';
import Renovationwork from '../../components/renovationworks/renovationworks';
import WhatsAppCTA from '../../components/whatsapp/whatappcta';
import ProjectSection3 from '../../components/ProjectSection3/ProjectSection3';




const RenovationWorkPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Renovation Works'} />
            <Renovationwork />

            <CtaSection />
            <ProjectSection3 />
            <Footer />
            <WhatsAppCTA />
            <Scrollbar />

        </Fragment>
    )
};

export default RenovationWorkPage ;